import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import MiniCartQuantity from "../mini-cart/mini-cart-content/mini-cart-quantity";

export default function SwatchProductActions({
  item,
  limitEach,
  onError = () => {},
  onAfterAdd = () => {},
  onAfterRemove = () => {},
  classPrefix,
  variantId,
  removeButtonClasses,
  addButtonClasses,
  addToCartText,
  removeFromCartText,
  swatchType,
  showWarning,
  removeAction,
}) {
  const [loading, setLoading] = useState(false);
  console.log(`loading`, loading);
  const handleAtcClick = () => {
    setLoading(true);

    window.addToCart(
      {
        id: variantId,
        quantity: 1,
        properties: {
          _is_swatch: "true",
          _swatch_type: swatchType,
        },
      },
      {
        onError: () => {
          onError();
          setLoading(false);
        },
        onAfterAdd: () => {
          onAfterAdd();
          setLoading(false);
        },
      },
    );
  };

  const handleRemoveClick = () => {
    if (removeAction) {
      removeAction();
      return;
    }

    setLoading(true);
    window.updateCart(
      { updates: { [item.id]: 0 } },
      {
        onError: () => {
          onError();
          setLoading(false);
        },
        onAfterAdd: () => {
          onAfterRemove();
          setLoading(false);
        },
      },
    );
  };

  return (
    <>
      <div className={`${classPrefix}__product-actions`}>
        {item && limitEach > 1 && (
          <MiniCartQuantity item={item} max={limitEach} />
        )}
        {item ? (
          <button
            type="button"
            className={`${removeButtonClasses} ${classPrefix}__remove`}
            onClick={handleRemoveClick}
          >
            {loading
              ? window.localeStrings.product.removing_from_cart
              : removeFromCartText}
          </button>
        ) : (
          <button
            type="button"
            className={`${addButtonClasses} ${classPrefix}__add-to-cart`}
            onClick={handleAtcClick}
          >
            {loading
              ? window.localeStrings.product.adding_to_cart
              : addToCartText}
          </button>
        )}
      </div>
    </>
  );
}
